// Reads the --bp-* custom properties defined in _scss/_variables.scss
// so JS media queries stay in sync with the Sass breakpoints.

export function breakpoint(name) {
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue(`--bp-${name}`)
        .trim();
    return window.matchMedia(`(min-width: ${value})`);
}
